export const NotificationType = Object.freeze({
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    NOT_AUTHENTICATED: "NOT_AUTHENTICATED",
    SUCCESS_PRIVATE: "SUCCESS_PRIVATE",
});
